<template>
    <b-container>
        <b-row>
            <b-col>
                <app-title
                    text="Evaluaciones de desempeño abiertas"
                ></app-title>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col>
                <app-open-performance-evaluation-list
                    ref="openPerformanceEvaluationList"
                    :table-data="tableData"
                    :on-change-page="onChangePage"
                    @open-team-evaluation-form="openTeamEvaluationForm"
                ></app-open-performance-evaluation-list>
            </b-col>
        </b-row>
        <b-row v-if="tableLength === 0">
            <b-col>
                <b-alert show
                    >Aún no hay evaluaciones de desempeño creadas</b-alert
                >
            </b-col>
        </b-row>
        <!-- início de popups -->
        <app-pop-up
            id="team-evaluation-form-window"
            title="Evaluación de equipo"
            size="large"
            @shown="$refs['team-evaluation-form'].loadTeamAndEvaluatedPeople()"
        >
            <template slot="body">
                <app-team-evaluation-form
                    v-if="!!currentEvaluation"
                    ref="team-evaluation-form"
                    :evaluation="currentEvaluation"
                    @close-popup-team-evaluation-form="
                        onClosePopupTeamEvaluation
                    "
                    @open-qualify-commitment-form="openQualifyCommitmentForm"
                ></app-team-evaluation-form>
            </template>
        </app-pop-up>
        <!--popup de evaluacion de compromiso  -->
        <app-pop-up
            id="commitment-qualification-form-window"
            title="Evaluación de compromiso"
            size="extra-large"
        >
            <template slot="body">
                <app-qualify-commitment-form
                    ref="qualifyCommitmentForm"
                    @close-popup-qualify-commitment-form="
                        onClosePopupQualifyCommitmentForm
                    "
                    @saved-qualification="onSavedQualification"
                    @error="onErrorQualification"
                ></app-qualify-commitment-form>
            </template>
            <template slot="buttons">
                <div>
                    <b-btn
                        variant="primary"
                        @click="saveQualificationCommitment"
                        :disabled="inProgress"
                    >
                        <i class="fa fa-save"></i> Guardar
                    </b-btn>
                </div>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import OpenPerformanceEvaluationList from './OpenPerformanceEvaluationList'
import appQualifyCommitmentForm from '../QualifyCommitmentForm'
import TeamEvaluationForm from '../TeamEvaluationForm'
export default {
    components: {
        appOpenPerformanceEvaluationList: OpenPerformanceEvaluationList,
        appTeamEvaluationForm: TeamEvaluationForm,
        appQualifyCommitmentForm,
    },
    data: () => ({
        page: 1,
        tableData: [],
        sortDir: 'desc',
        sortBy: 'created_at',
        tableLength: 0,
        evaluationId: 0,
        teamMember: [],
        currentEvaluation: null,
    }),
    methods: {
        async loadPerformanceEvaluations() {
            try {
                const params = {
                    page: this.page,
                    sortBy: this.sortBy,
                    sortDir: this.sortDir,
                }
                const { data } = await repo.get(
                    `performance-evaluations/leader-evaluations/${this.user.id}`,
                    {
                        ...params,
                    }
                )
                this.tableLength = data.data.length
                this.tableData = data
            } catch (err) {
                this.handleErrors(err)
            }
        },
        openTeamEvaluationForm(evaluation) {
            this.currentEvaluation = evaluation
            //this.$refs.teamEvaluationForms.loadTeamAndEvaluatedPeople()
            //this.$refs['team-evaluation-form'].loadTeamAndEvaluatedPeople()
            this.$bus.$emit('team-evaluation-form-window.open')
        },
        onClosePopupTeamEvaluation() {
            this.$bus.$emit('team-evaluation-form-window.close')
        },
        onChangePage(page) {
            this.page = page
            this.loadPerformanceEvaluations()
        },
        openQualifyCommitmentForm(evaluationMember) {
            this.$bus.$emit('team-evaluation-form-window.close')
            this.$bus.$emit('commitment-qualification-form-window.open')
            this.$refs.qualifyCommitmentForm.fillCommitments(evaluationMember)
        },
        onClosePopupQualifyCommitmentForm() {
            this.$bus.$emit('commitment-qualification-form-window.close')
        },
        saveQualificationCommitment() {
            this.$refs.qualifyCommitmentForm.saveQualification()
        },
        onSavedQualification(data) {
            this.$bus.$emit('validate-evaluation-status') //este evento se escucha en TeamEvaluationForm
            toastr.success(data.msg)
            this.$bus.$emit('commitment-qualification-form-window.close')

        },
        onErrorQualification() {
            toastr.error('Ocurrio un error al guardar la calificación')
            this.$bus.$emit('commitment-qualification-form-window.close')
        },
    },
    mounted() {
        this.loadPerformanceEvaluations()
    },
}
</script>
